import { getContactByCustomerIdOptions } from '@/modules/Customer/services'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { Option } from 'vnetwork-ui/dist/components/FormItem'
import AsyncSelect from '../AsyncSelect'
import { TFunction } from 'i18next'

interface ContactSelectProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    placeholder: string
    customer_id: number
    afterFetch?: (data: Option[]) => void
    t: TFunction
}

// Query key for contact select dropdown
// The AsyncSelect uses [name, ...dependencies] as query key
// So query key will be ['contact_id', customer_id]
export const getContactSelectQueryKey = (customerId: number) => [
    'contact_id',
    customerId,
]

const ContactSelect = <T extends FieldValues>({
    control,
    name,
    placeholder,
    customer_id,
    afterFetch,
    t,
}: ContactSelectProps<T>) => {
    return (
        <AsyncSelect<T>
            name={name}
            control={control}
            asyncOptions={async () =>
                customer_id ? getContactByCustomerIdOptions(customer_id, t) : []
            }
            placeholder={placeholder}
            label={placeholder}
            dependencies={[customer_id]}
            disabled={!customer_id}
            afterFetch={afterFetch}
            allowClear={false}
        />
    )
}

export default ContactSelect
